export default "__VITE_ASSET__4a01887e__"